

import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography
} from '@mui/material';
import successIcon from '../../assets/images/success.png';
import { useNavigate } from 'react-router-dom';

const ConfirmMailModal = ({
  open,
  disableConfirm = false


}) => {
      const navigate = useNavigate();

  const handleConfirm = () => {
    window.close();
  };
  
  return (
    <Dialog open={open}>
      <DialogTitle>Confirmation</DialogTitle>
      <DialogContent>
        <div style={{ textAlign: 'center', marginBottom: '15px' }}>
          <img
            src={successIcon}
            alt="Success"
            style={{ width: '80px', height: '80px', marginBottom: '10px' }}
          />
          <Typography variant="subtitle1" component="div">
            <ul style={{ margin: 0, paddingLeft: '1.25rem', textAlign: 'left' }}>
              <li>Mail has been send to the selected recipient successfully</li>
              {/* <li>You will be now redirected to Process Prescription Page</li> */}
            </ul>
          </Typography>
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleConfirm}
          variant="contained"
          //color="#ec008c"
          sx={{
                backgroundColor: '#ec008c',
                color: 'white',
                '&:hover': {
                backgroundColor: '#d5006d',
                },
            }}
          disabled={disableConfirm}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmMailModal;
